<template>
  <section id="repair-create-before-swiper">
    <div class="swiper-container" v-if="formatImgList[0]">
      <div class="swiper-container-large">
        <swiper :options="largeSwiperOption" ref="largeSwiper">
          <swiper-slide
            v-for="imgItem in formatImgList"
            :key="imgItem.photoUid"
          >
            <img :src="imgItem.photoUrl" class="imgItem" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <img
          :src="require('../../assets/images/swiper_button.svg')"
          class="swiper-prev-btn swiper-btn"
        />
        <img
          :src="require('../../assets/images/swiper_button.svg')"
          class="swiper-next-btn swiper-btn"
        />
      </div>
      <div class="swiper-container-small">
        <swiper ref="smallSwiper" class="small-swiper">
          <swiper-slide
            v-for="imgItem in formatImgList"
            :key="imgItem.photoUid"
          >
            <img :src="imgItem.photoUrl" class="small-item" />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </section>
</template>

<script>
import 'swiper/swiper-bundle.css';
// 按需引入swiper，及其函数
import {
  Swiper as SwiperClass,
  Pagination,
  Navigation,
  Thumbs
} from 'swiper/core';
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter';
SwiperClass.use([Pagination, Navigation, Thumbs]);
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
export default {
  props: {
    repairRecord: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      editImgList: [],
      showInner: false,
      imgTags: [
        {
          label: '主要立面',
          value: 'zhuYaoLiMian'
        },
        {
          label: '特色构件',
          value: 'teSeGouJian'
        },
        {
          label: '改动部位',
          value: 'gaiDongBuWei'
        }
      ],
      largeSwiperOption: {
        observer: true,
        observerParent: true,
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
          prevEl: '.swiper-prev-btn',
          nextEl: '.swiper-next-btn',
          disabledClass: 'my-button-disabled'
        },
        thumbs: {
          swiper: {
            el: '.small-swiper',
            slidesPerView: 5,
            observer: true,
            observerParent: true,
            watchSlidesVisibility: true
          },
          autoScrollOffset: 2,
          slideThumbActiveClass: 'small-swiper-active'
        }
      },
      checkedTags: [] // 选中的标签
    };
  },

  computed: {
    formatImgList() {
      return this.repairRecord.afterPhoto;
    }
  },

  methods: {}
};
</script>

<style lang="scss">
#repair-create-before-swiper {
  margin-top: 15px;
  .swiper-info {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    margin-bottom: 10px;
    height: 25px;
    &-text {
      line-height: 25px;
      color: #333;
      font-size: 15px;
      font-weight: 900;
    }
    .el-button {
      border: 0px;
      color: $color-primary;
      position: relative;
      .iconfont {
        font-size: 30px;
      }
      &:hover {
        color: $color-primary;
      }
      span {
        position: absolute;
        top: 10px;
      }
    }
  }
  .swiper-filter {
    .checked-tag {
      width: 80px;
      height: 35px;
      margin-right: 25px;
      .el-checkbox-button__inner {
        width: 95px;
        height: 35px;
        border-radius: 4px;
        border: 1px solid #333;
        text-align: left;
      }
    }
  }
  .swiper-container {
    margin-top: 10px;
    width: 630px;
    &-large {
      position: relative;
      height: 436px;
      .imgItem {
        height: 436px;
        width: 630px;
      }
      .swiper-btn {
        box-sizing: content-box;
        z-index: 200;
        padding: 10px 0;
        top: 193px;
        width: 40px;
        height: 40px;
        background-color: rgba($color: #ccc, $alpha: 0.3);
        cursor: pointer;
      }
      .swiper-prev-btn {
        position: absolute;
        left: 0px;
        transform: rotate(180deg);
      }
      .swiper-next-btn {
        position: absolute;
        right: 0px;
      }
    }
    &-small {
      margin-top: 5px;
      .swiper-slide {
        width: 100px !important;
        height: 100px;
        margin: 0 5px;
      }
      .small-item {
        width: 100px;
        height: 100px;
      }
      .small-swiper-active {
        img {
          border: 2px solid $color-primary !important;
        }
      }
    }
  }
  .my-button-disabled {
    display: none;
  }
  .active-button {
    background-color: $color-primary;
    color: #fff;
  }
}
</style>
